import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=3f3ed4e1"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"
import style0 from "./extension.vue?vue&type=style&index=0&id=3f3ed4e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports